import type { ButtonProps} from '@Components/button';
import {Button, ButtonType, ButtonSize} from '@Components/button';
import {getButtonPropsWithDefaultType} from '@Utils/button.util';

export type PanelFooterSecondaryDefaultActionProps = ButtonProps & {
  key: string;
  className?: string;
};

export function PanelFooterSecondaryDefaultAction({className = '', ...props}: PanelFooterSecondaryDefaultActionProps) {
  return <Button size={ButtonSize.LARGE} {...getButtonPropsWithDefaultType(props, ButtonType.SECONDARY)} customClasses={className} />;
}
